import PoDatePicker from "../PoDatePicker";

export const render_po_date_picker = (props) => {
  const { colDef, row } = props;
  const { field } = colDef;
  // const status = row[field];
  // if (row[field]) return <Box className="px-2">{row[field]}</Box>;
  return <PoDatePicker field={field} row={row} />;
};